import * as React from 'react';
import { useSnackbar } from 'notistack';
import { plainToInstance } from 'class-transformer';
import { useLocation, useNavigate } from 'react-router-dom';
import FormStepper from 'components/form-stepper/FormStepper';
import { TypeMode } from 'constants/TypeMode';
import StandardForm from 'components/shared/StandardForm';

// eslint-disable-next-line react/prop-types, no-unused-vars
const AddMissionPage = ({
    navigateTo,
    slice,
    service,
    pageTitle,
    config,
    entity,
}) => {
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();

    const location = useLocation();

    const handleOnClose = () => {
        navigate(navigateTo);
        navigate(navigateTo, { state: 'refresh' });
    };

    const handleOnSubmit = async data => {
        try {
            // eslint-disable-next-line react/prop-types
            const response = await service.create(data);
            enqueueSnackbar('Data saved', { variant: 'success' });
            navigate(`/mission/edit/${response.id}`);
        } catch (err) {
            enqueueSnackbar('An error occurred', {
                variant: 'error',
            });
        }
    };

    const defaultVal = React.useMemo(() => {
        let value = plainToInstance(
            entity,
            location?.state ? JSON.parse(location?.state)?.row : {},
            { exposeDefaultValues: true },
        );
        if (value.hasOwnProperty('parentUnitId')) {
            value = { ...value, parentUnitId: +value.parentUnitId };
        }
        delete value?.id;
        return value;
    }, [location?.state, entity]);

    return (
        <StandardForm
            title={pageTitle}
            mode={TypeMode.Create}
            status={'success'}
            formConfig={config}
            defaultValue={defaultVal}
            onClose={handleOnClose}
            onSubmit={handleOnSubmit}
            slice={slice}
        >
            {({ formConfig, methods, defaultValue, activeStep, mode }) => (
                <FormStepper
                    forms={formConfig}
                    methods={methods}
                    status={'success'}
                    defaultValue={defaultValue}
                    activeStep={activeStep}
                    mode={mode}
                />
            )}
        </StandardForm>
    );
};

export default AddMissionPage;
